/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import { APP_VERSION } from "../../version";
import "./TextCopyright.scss";

const TextCopyright = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="textCopyright">
      <div className="version">WebScheduler {APP_VERSION}</div>
      <div>© 2012-{currentYear} AlgoTraders. All Rights Reserved.</div>
    </div>
  );
};

export default TextCopyright;
